import { render } from "./PageSection.vue?vue&type=template&id=fafc6e50&scoped=true"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=fafc6e50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafc6e50"]])

export default __exports__